// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"Checkbox__checkbox___3NM1s"};